import { getPrivateFoldersWithOwner, createPrivateFolder, deletePrivateFolder, getUsersForRole, getEnrolledUsers, updateInstitutionPrivateFolder } from '../api'

export const loadPrivateFoldersWithOwner = ({ state, commit }) => {
  return getPrivateFoldersWithOwner()
}

export const deleteSeletedPrivateFolder = ({ state, commit }, uuid) => {
  return deletePrivateFolder(uuid)
}

export const createInstitutionPrivateFolder = ({ state, commit }, title) => {
  return createPrivateFolder(title)
}

export const loadUsersForRole = ({ state, commit }, data) => {
  return getUsersForRole(data)
}

export const loadEnrolledUsers = ({ state, commit }, parentSpaceId) => {
  return getEnrolledUsers(parentSpaceId)
}

export const updateInstitutionPrivateLibrary = ({ state, commit }, data) => {
  return updateInstitutionPrivateFolder(data)
}



// WEBPACK FOOTER //
// ./src/app/folderManagement/vuex/actions.js